import React, { Fragment, useState } from "react";
import { Collapse } from '@components';
import { PlusLg } from "react-bootstrap-icons";
import packageJson from '../../package.json';
import { PageHeader, PageSection, SupportEmail } from "@components";

const Support = () => {
  const initialFaqs = [{
    question: "Who are Ontik?",
    answer: <span>Ontik, registered as Ontik Technologies limited, is a UK based technology company building payment and credit risk software, revolutionising the way payments are made. Company number 14374185. For more information visit <a href="https://www.ontik.io/" target="_blank" rel="noreferrer noopener">our website</a></span>,
    isOpen: false
  },
  {
    question: "What is Pay by Bank?",
    answer: <span>Pay by Bank utilise open banking to transfer funds directly from your account to the receivers account. Transactions are immediate, safe and easy to complete.<br />
      Open banking enables third-party financial service providers to initiate bank transfers via APIs, facilitating secure payment processes.<br />
      In the UK, open banking is regulated by the Competition and Markets Authority (CMA) and overseen by the Open Banking Implementation Entity (OBIE). Banks provide APIs through a standardised framework, ensuring secure data sharing and compliance with strict regulatory standards.</span>,
    isOpen: false
  },
  {
    question: "How long does it take to receive funds?",
    answer: "Open banking payments will typically be received immediately upon processing of the payment. On occassion an open banking payment can take up to 2 hours to process. Card payments are processed by Adyen and this can take up to 7 days. Once processed they will settle in your card payments account. Payouts from this account to your bank occur daily. ",
    isOpen: false
  },
  {
    question: "How to send a payment link?",
    answer: <ol className="ps-3">
      <li>Login to your Ontik payments dashboard</li>
      <li>Go to ‘request payment’ section</li>
      <li>Select how would you like to send the link</li>
      <ol type="a">
        <li>Send SMS – An SMS with a payment link will be sent to a customer’s phone number</li>
        <li>QR code – QR code will be generate so that your customer can scan it to pay in person</li>
        <li>Share – A payment link will be generated, that you can copy and paste to your preferred communication channel with your customer</li>
      </ol>
      <li>Fill in the necessary fields and press Send/Generate/Share – depending on selected method.</li>
    </ol>,
    isOpen: false
  },
  {
    question: "How to issue a refund?",
    answer: <ol className="ps-3">
      <li>Login to your Ontik payments dashboard</li>
      <li>Go to ‘payment history’ section and select the payment you’d like to refund</li>
      <li>Select “Issue a refund” and enter the amount you’d like to refund. You can also make partial refunds.</li>
      <ol type="a">
        <li>If the payment was received via open banking, credentials of your customer may already be available to make the refund with one click. Alternatively, you may be asked to enter the account details of the account you are refunding to.</li>
        <li>You will then be asked to select the bank account from which you will be paying the refund. You will be redirected to your banking application to complete the refund.</li>
        <li>If the payment was paid by card, the refund will be processed using your card payments account. The funds can take 5 to 10 working days to process and will be drawn from your bank account.</li>
      </ol>
    </ol>,
    isOpen: false
  },
  {
    question: "Why are my card payments disabled?",
    answer: "Ontik have partnered with Adyen to provide card payments. Sometimes Adyen can require additional information to set-up your account. Ontik should be in touch to collect this information but if you have not received an email from us please contact support at teh email above.",
    isOpen: false
  }];

  return (
    <>
      <PageHeader>Support</PageHeader>
      <PageSection className="px-5 py-6">
        <h2 className="text-lg font-semibold mb-3">Contact us</h2>
        <p className="text-sm">If you have any issues or questions, please reach out to us at <SupportEmail /> and a member of our team will be in touch as soon as possible</p>
      </PageSection>
      <PageSection>
        <h2 className="text-lg font-semibold mb-3">FAQ</h2>
        {initialFaqs.map((x, i) => <Collapse header={x.question}>
          {x.answer}
        </Collapse>)}
      </PageSection>


    </>
  );
};

export default Support;
